import { useState } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { EnvService, IStorageSession } from 'namirasoft-core';
import { NSNotFoundPage } from 'namirasoft-site-react';
import { NSARouterMaker, NSARouterMakerProps } from 'namirasoft-account-react';
import { NamirasoftJobArrangerServer } from 'namirasoft-job-arranger';
import { JobArrangerRoutes } from "./JobArrangerRoutes";

// Pages
import Home from "./pages/HomePage";
import DashboardPage from "./pages/DashboardPage";
import LoginPage from './pages/LoginPage';

//job
import JobEditPage from "./pages/JobEditPage";
import JobViewPage from './pages/JobViewPage';
import JobListPage from './pages/JobListPage';

//reason
import ReasonViewPage from './pages/ReasonViewPage';
import ReasonEditPage from './pages/ReasonEditPage';
import ReasonListPage from './pages/ReasonListPage';
import { ProductUUID } from 'namirasoft-api-product';

export default function Router()
{
    let [state, setState] = useState<number>(Math.random());

    let location = useLocation();
    let navigate = useNavigate();

    let maker = new NSARouterMaker(ProductUUID.NAMIRASOFT_JOB_ARRANGER, new IStorageSession(), () => { setState(state + Math.random()); }, {
        onRenderOnLogin: (props: NSARouterMakerProps) =>
        {
            let REACT_APP_BASE_URL_JOB_ARRANGER = new EnvService("REACT_APP_BASE_URL_JOB_ARRANGER", true).getString();
            let server = {
                job_arranger: new NamirasoftJobArrangerServer(REACT_APP_BASE_URL_JOB_ARRANGER, props.account.token_manager, props.notifier.onError),
            }
            return (
                <>
                    <Routes>
                        <Route path={JobArrangerRoutes.Home} element={<Home {...props} />} />
                        <Route path={JobArrangerRoutes.Dashboard} element={<DashboardPage {...props} servers={server} />} />

                        <Route path={JobArrangerRoutes.JobList} element={<JobListPage {...props} servers={server} />} />
                        <Route path={JobArrangerRoutes.JobNew} element={<JobEditPage {...props} servers={server} isEdit={false} />} />
                        <Route path={JobArrangerRoutes.JobCopy(":id")} element={<JobEditPage {...props} servers={server} isEdit={false} />} />
                        <Route path={JobArrangerRoutes.JobEdit(":id")} element={<JobEditPage {...props} servers={server} isEdit={true} />} />
                        <Route path={JobArrangerRoutes.JobView(":id")} element={<JobViewPage {...props} servers={server} />} />

                        <Route path={JobArrangerRoutes.ReasonList} element={<ReasonListPage {...props} servers={server} />} />
                        <Route path={JobArrangerRoutes.ReasonNew} element={<ReasonEditPage {...props} servers={server} isEdit={false} />} />
                        <Route path={JobArrangerRoutes.ReasonCopy(":id")} element={<ReasonEditPage {...props} servers={server} isEdit={false} />} />
                        <Route path={JobArrangerRoutes.ReasonEdit(":id")} element={<ReasonEditPage {...props} servers={server} isEdit={true} />} />
                        <Route path={JobArrangerRoutes.ReasonView(":id")} element={<ReasonViewPage {...props} servers={server} />} />

                        <Route path="*" element={<NSNotFoundPage />} />
                    </Routes>
                </>
            );
        },
        onRenderOnLogout: () =>
        {
            return (
                <Routes>
                    <Route path={JobArrangerRoutes.Home} element={<LoginPage />} />
                    <Route path="*" element={<LoginPage />} />
                </Routes>
            );
        }
    }, location, navigate);

    return maker.onRender();
}